import { render, staticRenderFns } from "./AddTask.vue?vue&type=template&id=5e7475a0"
import script from "./AddTask.vue?vue&type=script&lang=js"
export * from "./AddTask.vue?vue&type=script&lang=js"
import style0 from "./AddTask.vue?vue&type=style&index=0&id=5e7475a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports